import { render, staticRenderFns } from "./BulkCheckbox.vue?vue&type=template&id=4f65bc9c"
import script from "./BulkCheckbox.vue?vue&type=script&lang=js"
export * from "./BulkCheckbox.vue?vue&type=script&lang=js"
import style0 from "./BulkCheckbox.vue?vue&type=style&index=0&id=4f65bc9c&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports